/* eslint-disable */
import { Box, Button, Grid, TextField, makeStyles } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { DateTime } from 'luxon';
import { useContext, useEffect, useState } from 'react';
import useSWR from 'swr';
import { MainContext } from '../../../context/ApiContext';
import useApp from '../../../hooks/useApp';
import { Nav, NavbarForm } from './styles';
import { fetcher } from '../../../service/SWRFetcher';
import filterStyles from '../../filterStyles';

const DatePeriodFilter = ({ corretora, filtersParams, setFiltersParams }) => {
  const { insurances } = useApp();

  const classes = filterStyles();

  const [filters, setFilters] = useState({
    date_ini: DateTime.now().plus({ months: -1 }).toISODate(),
    date_end: DateTime.now().toISODate(),
    partners: [],
    insurance_id: [],
    broker: [],
  });

  const { data: users } = useSWR(`/users`, fetcher, { revalidateOnFocus: false });
  const { data: partners } = useSWR(`/partners/by/auth`, fetcher, {
    revalidateOnFocus: false,
  });

  const handleChange = (e, inputValue = null, inputName = null) => {
    if (inputName) {
      setFilters({
        ...filters,
        [inputName]: inputValue?.id || [],
      });

      return;
    }

    e.preventDefault();

    const { name, value } = e.target;

    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleAutoCompleteChange = (e, value, inputName) => {
    e.preventDefault();

    const values = [];

    if (value) {
      value?.map((item) => {
        values.push(item?.id);
      });
    }

    if (values) {
      setFilters({
        ...filters,
        [inputName]: values,
      });
    }
  };

  const handleFilter = () => {
    setFiltersParams(filters);
  };

  return (
    <Box className={classes.boxFilter}>
      <Grid container spacing={2} alignItems="center">
        <Grid container item xs={12} md={12} alignItems="center" spacing={2}>
          <Grid item>
            <TextField
              className={classes.inputDate}
              type="date"
              name="date_ini"
              placeholder="Data Inicial"
              value={filters.date_ini}
              onChange={handleChange}
            />
          </Grid>

          <Grid item>
            <TextField
              className={classes.inputDate}
              type="date"
              name="date_end"
              placeholder="Data Final"
              value={filters.date_end}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <Autocomplete
              multiple
              fullWidth
              name="partners"
              options={partners ? partners : []}
              getOptionLabel={(option) => option?.name}
              onChange={(e, value) => handleAutoCompleteChange(e, value, 'partners')}
              className={classes.inputSelect}
              renderInput={(params) => <TextField {...params} variant="standard" placeholder="Empresas" />}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <Autocomplete
              className={classes.inputSelect}
              multiple
              options={insurances ? insurances.filter((i) => i.id <= 3) : []}
              getOptionLabel={(option) => option?.name}
              onChange={(e, value) => handleAutoCompleteChange(e, value, 'insurance_id')}
              renderInput={(params) => <TextField {...params} variant="standard" placeholder="Tipos de Estoque" />}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Autocomplete
              className={classes.inputSelect}
              options={users ? users : []}
              getOptionLabel={(option) => option?.name}
              onChange={(e, value) => handleChange(e, value, 'broker')}
              renderInput={(params) => (
                <TextField {...params} className="autocomplete" variant="standard" placeholder="Corretor" />
              )}
            />
          </Grid>

          <Grid item>
            <Button fullWidth className={classes.button} onClick={handleFilter}>
              Filtrar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DatePeriodFilter;
